import React from 'react'
import { Text } from 'react-native'
import {
  BG_STYLES,
  Button,
  BUTTON_TYPE,
  CenterModal,
  COMMON_STYLES,
  SIZE,
  TEXT_STYLES,
  TYPOGRAPHY,
} from '@dehaat/dds'
import { useTranslation } from 'react-i18next'

type Props = {
  styles: any
  isVisible: boolean
  message: string
  onClose: () => void
}

const DemoActionResultModal = ({ styles, isVisible, message, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <CenterModal isVisible={isVisible} onClose={() => null} allowClose={false}>
      <Text style={[TYPOGRAPHY.HEADING3, TEXT_STYLES.textNeutral90]}>
        {t('demo_action_result')}
      </Text>
      <Text style={[TYPOGRAPHY.TEXT2, TEXT_STYLES.textNeutral80, COMMON_STYLES.mv1]}>
        {message}
      </Text>
      <Button
        buttonStyle={[BG_STYLES.bgPrimary100, styles.modalBtn]}
        onClick={onClose}
        type={BUTTON_TYPE.PRIMARY}
        text={t('okay')}
        size={SIZE.small}
        textStyle={[TEXT_STYLES.textNeutral00]}
      />
    </CenterModal>
  )
}

export default DemoActionResultModal
